import React from 'react';
import { Box } from '@material-ui/core';
import HomeComponent from 'components/Home/index';

const Home = () => {
  return (
    <Box>
      <HomeComponent />
    </Box>
  );
};

export default Home;
